module.exports = __webpack_public_path__ + "static/media/visa.4af1fa58.svg";